import { AfterViewInit, Component, DestroyRef, inject, signal } from '@angular/core';
import { SolDebugInfoComponent } from '../sol-debug-info/sol-debug-info.component';
import { DebugService } from '../../../services/debug.service';
import { TimerTools } from '../../../tools/timer-tools';

@Component({
  selector: 'sol-debugger',
  imports: [SolDebugInfoComponent],
  templateUrl: './sol-debugger.component.html',
})
export class SolDebuggerComponent implements AfterViewInit {
  // Dependencies
  private readonly debugService = inject(DebugService, { optional: true });
  private readonly destroyRef = inject(DestroyRef);

  // Computed
  protected readonly visible$ = signal<boolean>(false);

  ngAfterViewInit(): void {
    if (this.debugService) {
      TimerTools.interval$(500, this.destroyRef).subscribe(() => {
        const visible = this.debugService!.state.visible;
        if (this.visible$() !== visible) {
          this.visible$.set(visible);
        }
      });
    }
  }
}
